var render = function () {
  var _vm$gift, _vm$gift$sender;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--lg"
  }, [_c('span', {
    staticClass: "pl-4"
  }, [_vm._v("캐시선물받기")])]), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "tit tit--xs"
  }, [_c('div', {
    staticClass: "pl-4"
  }, [_c('v-img', {
    staticClass: "mx-auto my-4",
    attrs: {
      "src": "/images/mypage/present.png",
      "width": "128"
    }
  })], 1), _c('div', {
    staticClass: "text-center mt-8"
  }, [_c('div', [_c('b', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s((_vm$gift = _vm.gift) === null || _vm$gift === void 0 ? void 0 : (_vm$gift$sender = _vm$gift.sender) === null || _vm$gift$sender === void 0 ? void 0 : _vm$gift$sender.name))]), _vm._v("님께서")]), _c('div', [_vm._v("보내주신 선물을 받으시겠습니까?")])])]), _c('v-card-text', {
    staticClass: "tit tit--xs"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("선물을 받을경우 "), _c('b', {
    staticClass: "tit tit--xs teal--text"
  }, [_vm._v(_vm._s(_vm.gift.amount.format()))]), _vm._v(" 캐시가 생성됩니다.")])]), _c('v-responsive', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "max-width": "400"
    }
  }, [_c('v-card-actions', {
    staticClass: "pb-8 flex-column align-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('v-btn', {
    staticClass: "white--text ma-0",
    attrs: {
      "color": "teal",
      "x-large": "",
      "width": "100%",
      "max-width": "300"
    },
    on: {
      "click": _vm.take
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-gift-outline")]), _vm._v("선물받기")], 1), _c('v-btn', {
    staticClass: "white--text ma-0",
    attrs: {
      "color": "error",
      "x-large": "",
      "width": "100%",
      "max-width": "300"
    },
    on: {
      "click": _vm.reject
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-hand-front-right-outline")]), _vm._v("거절하기")], 1)], 1)], 1)], 1), _c('login-dialog', {
    ref: "loginDialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }